<p>
  Versetzt den Vorgang in den Status
  <i>Warten auf Bestellung</i>
  und versendet eine E-Mail mit dem Angebot an den Kunden und den verantwortlichen Installateur.
</p>
<form [formGroup]="formGroup">
  <section fxLayout="column" fxLayoutAlign="start">
    <mat-form-field appearance="outline" style="margin-bottom: 0.5rem" fxFlexAlign="stretch">
      <mat-label>Kommentar</mat-label>
      <textarea
        matInput
        type="text"
        rows="3"
        maxlength="1500"
        required
        [formControl]="formGroup.controls.comment"></textarea>
    </mat-form-field>
  </section>
</form>

<div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
  <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>
  <button
    mat-raised-button
    color="primary"
    id="modal-confirm-after-meter-change"
    (click)="confirm(formGroup)">
    Angebot versenden
  </button>
</div>
